import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { config } from '../config/config';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  private apiUrl = `${config.examApiBaseUrl}/call`; // From ExamApp

  constructor(private http: HttpClient) { }

  getCandidateResults(examAttendNumber?: string, idNumber?:number, startDate?: Date, endDate?: Date, courseName?: string): Observable<any> {
    const body = {
      procedureName: 'GetCandidateResults',
      params: {
        ExamAttendanceNo: examAttendNumber,
        IDNumber: idNumber,
        StartExamDate: startDate,
        EndExamTime: endDate,
        CourseName: courseName
      }
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }

  getTestDetails(examAttendNumber?: string): Observable<any> {
    const body = {
      procedureName: 'TestDetails',
      params: {
        ExamAttendanceNo: examAttendNumber,
      }
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }

  getExamViolations(): Observable<any>{
      const body = {
      procedureName: 'getExamViolations',
      params: {}
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }


  getCandidateDistribution(year: number | null): Observable<any> {
    const body = {
      procedureName: 'CandidateDistribution',
      params: {
        Year: year
      }
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }

}
